export interface ComparisonRow {
  label: string;
  cells: string[];
}

interface ComparisonTableProps {
  // Column headings after the (visually hidden) row-label column.
  columns: string[];
  rows: ComparisonRow[];
  // Screen-reader name for the row-label column header.
  rowHeader?: string;
}

// Side-by-side comparison. Scrolls sideways on phones rather than squashing
// the columns, so the wrapper is a focusable, labelled region.
const ComparisonTable = ({
  columns,
  rows,
  rowHeader = "Aspect",
}: ComparisonTableProps) => (
  <div
    tabIndex={0}
    role="region"
    aria-label="Table. Scroll sideways to see more."
    className="mt-3 overflow-x-auto rounded-3xl border border-line bg-white"
  >
    <table className="w-full min-w-[640px] border-collapse text-left text-[15.5px]">
      <thead>
        <tr className="bg-paper">
          <th scope="col" className="px-[22px] py-4">
            <span className="sr-only">{rowHeader}</span>
          </th>
          {columns.map((column) => (
            <th key={column} scope="col" className="px-[22px] py-4 font-semibold">
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label} className="border-t border-line align-top">
            <th scope="row" className="px-[22px] py-4 font-semibold">
              {row.label}
            </th>
            {row.cells.map((cell, index) => (
              <td key={index} className="px-[22px] py-4 text-ink-muted">
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ComparisonTable;
